const generateGradient = (
    ctx: CanvasRenderingContext2D,
    gradientColors: string[]
): CanvasGradient => {
    const gradient = ctx.createLinearGradient(0, 0, 300, 0)
    gradientColors.forEach((color, index) => {
        const position = index / (gradientColors.length - 1)
        gradient.addColorStop(position, color)
    })
    return gradient
}

export const graphGradients = (
    ctx: CanvasRenderingContext2D,
    gradientArray: string[][]
) => gradientArray.map((gradient) => generateGradient(ctx, gradient))
